export const addVconsole = async () => {
  if (process.env.VUE_APP_USE_VCONSOLE === 'true') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const VConsole = (await import('vconsole' as any)).default;
      const vConsole = new VConsole();
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      vConsole.setSwitchPosition(200, 200);

      // 点击刷新
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const refreshPlugin = new (VConsole as any).VConsolePlugin('refresh_page', 'Refresh');
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      refreshPlugin.on('renderTab', function (callback: any) {
          callback('Click Button to reload Page');
      });
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      refreshPlugin.on('addTool', function (callback: any) {
          callback([
              {
                  name: 'Reload',
                  onClick: function () {
                      location.reload();
                  },
              },
          ]);
      });
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      vConsole.addPlugin(refreshPlugin);
  }
}
